import { BaseEntity } from "yt-ng-framework";

export class VrstaIzostanka extends BaseEntity{
    constructor(){
        super();
    }

    Naziv: string=null;
    Oznaka: string=null;
    Sati: number=null;

    Deserialize(input: any) {
        this.ID=input.ID;
        this.Naziv=input.Naziv;
        this.Oznaka=input.Oznaka;
        this.Sati=input.Sati;
        return this;
    }

    Serialize(input: VrstaIzostanka) {
        return input;
    }
}